export default function AppSection() {
  return (
    <section id="app" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-gradient-to-br from-background-100 to-background-200/50 rounded-2xl p-8 md:p-12 border border-background-300/30">
            <div className="flex-1 text-center lg:text-left">
              <h2 className="font-heading text-2xl md:text-3xl text-foreground-50 mb-4">
                移动追剧 · 随时随地看全集
              </h2>
              <p className="text-foreground-400 text-sm md:text-base leading-relaxed mb-6">
                萝卜影视移动端适配完美，支持手机与平板在线观看电视剧全集。无论是在通勤路上、午休时间还是睡前放松，打开手机即可畅享高清电视剧在线全集，无需下载任何应用，浏览器直接访问，流畅播放不卡顿。
              </p>
              <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-6">
                <div className="flex items-center gap-2 text-foreground-300 text-sm">
                  <i className="ri-smartphone-line text-accent-400 text-lg"></i>
                  <span>手机浏览器直接访问</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-300 text-sm">
                  <i className="ri-tablet-line text-accent-400 text-lg"></i>
                  <span>平板大屏追剧</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-300 text-sm">
                  <i className="ri-wifi-line text-accent-400 text-lg"></i>
                  <span>无需下载安装</span>
                </div>
              </div>
              <a
                href="#hero"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#hero')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-primary-500 hover:bg-primary-600 text-foreground-50 font-medium text-sm whitespace-nowrap cursor-pointer transition-colors duration-200"
              >
                <i className="ri-play-circle-line"></i>
                立即体验
              </a>
            </div>
            <div className="flex-shrink-0">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20displaying%20a%20dark%20cinematic%20streaming%20interface%20with%20movie%20poster%20thumbnails%20in%20a%20grid%20layout%2C%20warm%20red%20and%20dark%20theme%2C%20elegant%20UI%20design%2C%20floating%20on%20a%20dark%20background%20with%20subtle%20glow%2C%20minimal%20app%20interface%20mockup%2C%20sophisticated%20presentation&width=400&height=600&seq=app-mobile-luobo-01&orientation=portrait"
                alt="萝卜影视移动端追剧体验"
                className="w-[220px] md:w-[280px] h-auto rounded-2xl"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}